<template>
  <v-dialog @input="change" value="true" :fullscreen="isMobileOnly" :content-class="'app-dialog ' + (isMobileOnly ? 'mobile' : '')"
    :max-width="dialogMaxWidth" @keydown="dialog_OnKeyDown" @click:outside="actionSelected(null)">

    <v-card class="choose-action-dlg">
      <v-toolbar color="app-colors-background-light" class="app-dialog-header">
        <v-toolbar-title :class="$vuetify.breakpoint.xsOnly ? 'app-dialog-title-mobile' : ''" v-text="getLocale(title)" />
      </v-toolbar>
      <v-card-text class="app-dialog-body py-3">
        <div v-for="(action, idx) in actions" :key="idx" class="d-flex justify-end mt-2 overflow-x-hidden">
          <v-btn color="primary" outlined :class="isMobileOnly ? 'text-body-2' : 'text-body-1'" @click="actionSelected(action)">
            {{ getLocale(action.text) }}
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions class="app-dialog-footer">
        <v-btn color="secondary" @click="actionSelected(null)">
          {{ getLocale('buttons.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { isMobileOnly } from 'mobile-device-detect';

import { getLocale } from '@/helpers/locale-helper';

export default {
  name: 'ChooseActionDlg',
  props: {
    onResult: { type: Function, default: () => {} },
    title: { type: String, default: 'chooseActionDlg.title' },
    width: { type: String, default: null },
    actions: { type: Array, default: () => [] }
  },
  data() {
    return {
      action: undefined,
      dialogMaxWidth: 'fit-content',
      value: false
    };
  },
  computed: {
    getLocale() { return getLocale; },
    isMobileOnly() { return isMobileOnly; }
  },
  created() {
    if (this.width) {
      this.dialogMaxWidth = this.width;
    }
  },
  beforeDestroy() {
    this.onResult(this.action);
  },
  methods: {
    actionSelected(action) {
      this.action = action;
      this.submit();
    },
    change() { this.$destroy(); },
    dialog_OnKeyDown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        this.action = null;
        this.submit();
      }
    },
    submit() {
      this.$emit('result', this.action);
      this.$destroy();
    }
  }
};
</script>

<style lang="scss">
.choose-action-dlg {
  .app-dialog-header {
    .v-icon {
      font-size: 1.5em;
    }

    .app-dialog-title-mobile {
      font-size: 1.15em;
    }
  }

  .app-dialog-body {
    max-height: 50vh;
    min-height: 75px;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
